"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const FieldsSetupFlowController_1 = __importDefault(require("../modules/controllers/FieldsSetupFlowController"));
const Crop_1 = __importDefault(require("@becrop/abstract/Models/Crop"));
const MetadataLibrary_1 = __importDefault(require("@becrop/components/ClientFarmListView/modules/models/MetadataLibrary"));
const Toggle_vue_1 = __importDefault(require("@becrop/components/DashboardSingle/components/Toggle.vue"));
const CenterUtility_1 = require("@becrop/components/Map/models/CenterUtility");
const parcel_1 = __importDefault(require("@becrop/components/Results/DistroTool/controllers/services/parcel"));
const Utils_1 = require("@becrop/components/Map/Utils");
const trans_1 = require("@common/tsutils/trans");
const lucide_vue_next_1 = require("lucide-vue-next");
const WKT_1 = __importDefault(require("ol/format/WKT"));
const GeometryCollection_1 = __importDefault(require("ol/geom/GeometryCollection"));
const easing_1 = require("ol/easing");
const proj_1 = require("ol/proj");
const style_1 = require("ol/style");
const floating_vue_1 = require("floating-vue");
let FieldsTable = class FieldsTable extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.globalFieldName = '';
        this.globalFarmName = '';
        this.practicesGlobal = null;
        this.cropGlobal = null;
        this.fieldsChecked = [];
        this.isCheckedGlobal = false;
        this.CONTROLLER = FieldsSetupFlowController_1.default.getInstance();
        this.STEP_MODEL = this.CONTROLLER.fieldsPreviewTableStep;
        this.rowIndex = null;
        this.editMode = null;
        this.modalField = false;
        this.modalFarm = false;
        this.modalCrop = false;
        this.modalPractice = false;
        this.modalRemoveField = false;
        this.modalAdvancedEdition = false;
        this.bulkMode = false;
        this.fieldCenterId = -1;
        this.editFieldName = '';
        this.fieldClicked = null;
        this.fieldEdited = null;
        this.editFarmName = '';
        this.editvalidFields = [];
        this.tempFieldNames = [];
        this.pendingToSave = false;
        this.fields_wkt = [];
        // ----------------
        this.EARTH_RADIUS_KM = 6371;
        this.MAX_DISTANCE_KM = 25;
        // ----------------
    }
    get isLastField() {
        return (this.fields.length === 1);
    }
    get timeAvailable() {
        return this.time === null || !this.time.locked;
    }
    closeToast() {
        this.$emit('closeToast');
    }
    focusFarm(field) {
        const fields_wkt = [];
        const farm = this.STEP_MODEL.data.selectedFields.filter((fieldFilter) => fieldFilter.farmName === field.farmName);
        for (const fieldToFarm of farm) {
            fields_wkt.push(fieldToFarm.geodata);
        }
        if (fields_wkt.length > 0) {
            const polygonsWkt = fields_wkt.map(Utils_1.parseWKT);
            if (polygonsWkt) {
                const combinedGeometry = new GeometryCollection_1.default(polygonsWkt);
                const extent = (0, proj_1.transformExtent)(combinedGeometry.getExtent(), 'EPSG:4326', 'EPSG:3857');
                this.map.map.getView().fit(extent, { duration: 700, easing: easing_1.easeOut, padding: [50, 50, 50, 50] });
            }
        }
    }
    get isAddingFields() {
        return this.CONTROLLER.isAddingFields;
    }
    evaluatePendingToSave() {
        if (!this.updatingField)
            this.unsetPendingToSave();
        if (this.updatingField)
            this.setPendingToSave();
    }
    setPendingToSave() {
        this.pendingToSave = true;
    }
    unsetPendingToSave() {
        this.pendingToSave = false;
    }
    confirmFieldEdition(f) {
        this.$emit('updateField', f);
    }
    undoFieldEdition(f) {
        this.$emit('undoFieldEdition', f);
    }
    updatePlantYear(newValue) {
        if (this.fieldEdited.advancedMetadata.plant_year !== newValue) {
            this.fieldEdited.advancedMetadata.plant_year = newValue;
            this.setPendingToSave();
        }
    }
    updateVariety(newValue) {
        if (this.fieldEdited.advancedMetadata.variety !== newValue) {
            this.fieldEdited.advancedMetadata.variety = newValue;
            this.setPendingToSave();
        }
    }
    updateDensity(newValue) {
        if (this.fieldEdited.advancedMetadata.density.value !== parseInt(newValue)) {
            this.fieldEdited.advancedMetadata.density.value = parseInt(newValue);
            this.setPendingToSave();
        }
    }
    toggleArtificialIrrigation() {
        this.fieldEdited.advancedMetadata.practices.artificial_irrigation.enabled = !this.fieldEdited.advancedMetadata.practices.artificial_irrigation.enabled;
        this.setPendingToSave();
    }
    updateArtIrrigUsage(newValue) {
        if (this.fieldEdited.advancedMetadata.practices.artificial_irrigation.uses !== newValue.value) {
            this.fieldEdited.advancedMetadata.practices.artificial_irrigation.uses = newValue.value;
            this.setPendingToSave();
        }
    }
    updateArtIrrigType(newValue) {
        if (this.fieldEdited.advancedMetadata.practices.artificial_irrigation.type !== newValue.value) {
            this.fieldEdited.advancedMetadata.practices.artificial_irrigation.type = newValue.value;
            this.setPendingToSave();
        }
    }
    toggleBioDynamicPractices() {
        this.fieldEdited.advancedMetadata.practices.biodynamic_practices.enabled = !this.fieldEdited.advancedMetadata.practices.biodynamic_practices.enabled;
        this.setPendingToSave();
    }
    saveFieldMetadataEdition() {
        this.$emit('updateField', this.fieldEdited, 'metadata');
    }
    defaultPractice(prac) {
        if (prac && prac.length > 0) {
            const id = prac[0];
            let manag;
            if (this.isEditionMode) {
                manag = this.metadataLibrary.practices.find((p) => p.id === id);
            }
            if (this.isCreationMode) {
                manag = this.CONTROLLER.managementPractices.find((p) => p.id === id);
            }
            if (manag) {
                return {
                    label: manag.name,
                    value: manag.id
                };
            }
        }
    }
    get artIrrigUsageOptions() {
        if (this.isEditionMode) {
            return this.metadataLibrary.artificialIrrigationUsages.map((a) => {
                return {
                    label: a.name,
                    value: a.id
                };
            });
        }
        return [];
    }
    get artIrrigTypeOptions() {
        if (this.isEditionMode) {
            return this.metadataLibrary.artificialIrrigationTypes.map((a) => {
                return {
                    label: a.name,
                    value: a.id
                };
            });
        }
        return [];
    }
    get defaultIrrigType() {
        const irrigTypeId = this.fieldEdited.advancedMetadata.practices.artificial_irrigation.type;
        return this.artIrrigTypeOptions.find((o) => o.value === irrigTypeId);
    }
    get defaultIrrigUsage() {
        const irrigUsageId = this.fieldEdited.advancedMetadata.practices.artificial_irrigation.uses;
        return this.artIrrigUsageOptions.find((o) => o.value === irrigUsageId);
    }
    get practicesOptions() {
        if (this.isCreationMode) {
            return this.CONTROLLER.managementPractices.map(practice => practice.name);
        }
        if (this.isEditionMode) {
            return this.metadataLibrary.practices.map((p) => {
                return {
                    label: p.name,
                    value: p.id
                };
            });
        }
        return [];
    }
    get cropOptions() {
        if (this.isCreationMode) {
            return this.CONTROLLER.crops.map(crop => crop.name);
        }
        if (this.isEditionMode) {
            return this.metadataLibrary.crops.map((crop) => {
                return {
                    label: crop.name,
                    value: crop.id
                };
            });
        }
        return [];
    }
    get isCreationMode() {
        return this.mode === 'create';
    }
    get isEditionMode() {
        return this.mode === 'edit';
    }
    addNewField() {
        this.$emit('addNewField');
    }
    clickThisField(f) {
        this.fieldClicked = f;
        this.fieldEdited = JSON.parse(JSON.stringify(f));
    }
    advancedEdition() {
        this.$emit('initializeFieldUpdate');
        this.modalAdvancedEdition = true;
    }
    requestFieldRemoval(f) {
        this.clickThisField(f);
        this.modalRemoveField = true;
    }
    confirmFieldRemoval() {
        this.$emit('confirmFieldRemoval', this.fieldClicked);
    }
    fieldSetSizeUnit() {
        this.fields.forEach((field) => {
            field.setAcreageUnit();
        });
    }
    fillTempFieldNames() {
        this.tempFieldNames = this.fields.map((f) => f.fieldName);
    }
    updated() {
        this.fillTempFieldNames();
    }
    mounted() {
        if (this.STEP_MODEL.data.fields.length > 0) {
            if (this.isAddingFields) {
                for (const field of this.STEP_MODEL.data.fields) {
                    this.editvalidFields = this.STEP_MODEL.data.fields.filter((f) => f.closeToFarm);
                }
            }
            if (this.CONTROLLER.userCurrentCrop) {
                this.fields.forEach(field => { if (field.crop.id === -1) {
                    field.setCrop(this.CONTROLLER.userCurrentCrop);
                } });
            }
            this.alertFieldsDimension();
            this.fillTempFieldNames();
        }
        this.isCheckedGlobal = true;
    }
    parcelFillColor(field) {
        var _a;
        if (field.crop)
            return `${(_a = field.crop) === null || _a === void 0 ? void 0 : _a.color}50`;
        else
            return '#eebb5450';
    }
    parcelStrokeColor(field) {
        var _a;
        if (field.crop)
            return (_a = field.crop) === null || _a === void 0 ? void 0 : _a.color;
        else
            return '#eebb54';
    }
    findCrop(cropName) {
        let crop = new Crop_1.default({});
        if (this.isCreationMode) {
            crop = this.CONTROLLER.crops.find((crop) => cropName === crop.name);
        }
        if (this.isEditionMode) {
            crop = this.metadataLibrary.crops.find((crop) => cropName === crop.name);
        }
        if ((crop === null || crop === void 0 ? void 0 : crop.icon) && (crop === null || crop === void 0 ? void 0 : crop.icon.length) > 0) {
            return `/crop/pic/background/${crop.icon}/Soil`;
        }
        else {
            return '';
        }
    }
    deployModalField(bulk) {
        this.modalField = true;
        this.bulkMode = bulk;
    }
    dismissModal() {
        this.modalField = false;
        this.bulkMode = false;
    }
    deployModalFarm(bulk) {
        this.modalFarm = true;
        this.bulkMode = bulk;
    }
    dismissFarm() {
        this.modalFarm = false;
        this.bulkMode = false;
    }
    dismissRemoveField() {
        this.modalRemoveField = false;
        this.bulkMode = false;
        this.$emit('initializeFieldRemoval');
    }
    deployModalAdvancedEdition(bulk) {
        this.$emit('initializeFieldUpdate');
        this.modalAdvancedEdition = true;
        this.bulkMode = bulk;
    }
    dismissAdvancedEdition() {
        this.modalAdvancedEdition = false;
        this.bulkMode = false;
    }
    deployModalCrop() {
        this.modalCrop = true;
        this.bulkMode = true;
    }
    deployModalPractices() {
        this.modalPractice = true;
        this.bulkMode = true;
    }
    isDuplicateFieldName(name) {
        return this.fields.some(field => field.fieldName === name);
    }
    validateAndSaveFarm() {
        const currentField = this.STEP_MODEL.data.fields[this.rowIndex];
        // Agrupar los campos por distancia
        const groupFields = this.groupFieldsByDistance(this.STEP_MODEL.data.fields);
        // Encontrar el grupo del campo actual
        let currentGroupId = null;
        for (const [groupId, fields] of Object.entries(groupFields)) {
            if (fields.fields.includes(currentField)) {
                currentGroupId = groupId;
                break;
            }
        }
        if (!currentGroupId) {
            console.error('No se encontró el grupo del campo actual.');
            return;
        }
        // Verificar si el nombre ya existe en otro grupo
        let isDuplicateInAnotherGroup = false;
        for (const [groupId, fields] of Object.entries(groupFields)) {
            if (groupId === currentGroupId)
                continue; // Omitimos el grupo actual
            if (fields.fields.some(field => field.farmName === this.editFarmName)) {
                isDuplicateInAnotherGroup = true;
                break;
            }
        }
        // Si hay conflicto con otro grupo, agregamos el ID del grupo al nombre
        if (isDuplicateInAnotherGroup) {
            currentField.farmName = `${this.editFarmName}_${currentGroupId}`;
            const msg = `${(0, trans_1.trans)('setup_activation.autobreak.alert_2_1')}${this.editFarmName}_${currentGroupId}${(0, trans_1.trans)('setup_activation.autobreak.alert_2_2')}`;
            this.$emit('editFarmName', msg);
        }
        else {
            currentField.farmName = this.editFarmName;
        }
        this.editFarmName = '';
    }
    validateAndSave() {
        if (this.isCreationMode) {
            if (this.isDuplicateFieldName(this.editFieldName)) {
                this.STEP_MODEL.data.fields[this.rowIndex].fieldName = `${this.fields[this.rowIndex].id}_${this.editFieldName}`;
            }
            else {
                this.STEP_MODEL.data.fields[this.rowIndex].fieldName = this.editFieldName;
            }
        }
        if (this.isEditionMode) {
            const field = this.fieldsFilters[this.rowIndex];
            if (this.editFieldName.length > 0) {
                field.fieldName = this.editFieldName;
                this.$emit('setFieldAsEditing', field, 'name');
            }
        }
    }
    // Desactiva el modo de edición
    deactivateEdit() {
        if (this.editMode === 'fieldName') {
            this.validateAndSave();
        }
        if (this.editMode === 'farmName') {
            // this.validateAndSaveFarm();
            this.$emit('editIndividualFarmName', this.editFarmName, this.STEP_MODEL.data.fields[this.rowIndex]);
        }
        this.rowIndex = null;
        this.editMode = null;
        this.editFieldName = '';
    }
    undoEdit() {
        this.rowIndex = null;
        this.editMode = null;
    }
    modelEmitGlobalPractices(practice) {
        this.practicesGlobal = this.CONTROLLER.managementPractices.find((practices) => { return practices.name === practice; });
    }
    modelGlobalEmitCrop(cropName) {
        this.cropGlobal = this.CONTROLLER.crops.find((crop) => { return crop.name === cropName; });
    }
    get projections() {
        return { dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857' };
    }
    async centerZone(extent, padding) {
        await (0, CenterUtility_1.center)(this.map.map, extent, 700, padding);
    }
    async centerShapes() {
        const fields_wktt = [];
        this.STEP_MODEL.data.selectedFields.forEach((field) => {
            fields_wktt.push(field.geodata);
        });
        if (fields_wktt.length > 0) {
            const polygonsWkt = fields_wktt.map(Utils_1.parseWKT);
            if (polygonsWkt) {
                const combinedGeometry = new GeometryCollection_1.default(polygonsWkt);
                const extent = (0, proj_1.transformExtent)(combinedGeometry.getExtent(), 'EPSG:4326', 'EPSG:3857');
                this.map.map.getView().fit(extent, { duration: 700, easing: easing_1.easeOut, padding: [50, 50, 50, 50] });
            }
        }
    }
    async centerField(id, geodata) {
        const feature = new WKT_1.default().readFeature(geodata, this.projections);
        const geometry = feature.getGeometry();
        if (this.fieldCenterId === id) {
            this.fieldCenterId = -1;
        }
        else {
            this.fieldCenterId = id;
        }
        if (geometry) {
            const ext = geometry.getExtent();
            if (ext) {
                this.map.map.getView().fit(ext, { duration: 700, easing: easing_1.easeOut, padding: [50, 50, 50, 50] });
            }
        }
    }
    deactivateEditGlobal(mode) {
        if (mode === 'fieldName') {
            this.dismissModal();
            if (this.STEP_MODEL.data.selectedFields.length < 1) {
                this.fields.forEach((field, index) => {
                    if (this.globalFieldName.length > 0) {
                        field.setName(`${this.globalFieldName}_${index}`);
                    }
                });
            }
            else {
                this.STEP_MODEL.data.selectedFields.forEach((field, index) => {
                    if (this.globalFieldName.length > 0) {
                        field.setName(`${this.globalFieldName}_${index}`);
                    }
                });
            }
            const msg = `${(0, trans_1.trans)('setup_activation.autobreak.alert_4')}`;
            this.$emit('editFieldName', msg);
        }
        else if (mode === 'farmName') {
            this.dismissFarm();
            const msg = `${(0, trans_1.trans)('setup_activation.autobreak.alert_5')}`;
            this.$emit('editFarmName', msg);
            this.$emit('editBulkFarmName', this.globalFarmName);
        }
        else if (mode === 'crop') {
            this.modalCrop = false;
            if (this.STEP_MODEL.data.selectedFields.length < 1) {
                this.fields.forEach(field => { field.setCrop(this.cropGlobal); this.changeFieldsStyle(field); });
            }
            else {
                this.STEP_MODEL.data.selectedFields.forEach(field => { field.setCrop(this.cropGlobal); this.changeFieldsStyle(field); });
            }
            this.$emit('editFarmNameByCrop');
        }
        else if (mode === 'practice') {
            this.modalPractice = false;
            if (this.STEP_MODEL.data.selectedFields.length < 1) {
                this.fields.forEach(field => { field.setManagementPractice(this.practicesGlobal); });
            }
            else {
                this.STEP_MODEL.data.selectedFields.forEach(field => { field.setManagementPractice(this.practicesGlobal); });
            }
        }
    }
    activateEdit(rowIndex, fieldName) {
        this.rowIndex = rowIndex;
        this.editMode = fieldName;
        if (fieldName === 'farmName') {
            this.editFarmName = this.fields[rowIndex].farmName;
        }
        if (fieldName === 'fieldName') {
            this.editFieldName = this.fields[rowIndex].fieldName;
        }
    }
    changeIsCheckedGlobal(newValue) {
        this.isCheckedGlobal = newValue;
        if (!this.isCheckedGlobal)
            this.fieldsChecked = [];
    }
    parcelSvg(polygon) {
        return (0, parcel_1.default)(polygon, 45, 45);
    }
    isFieldCheck(fieldId) {
        return !!this.fieldsChecked.includes(fieldId);
    }
    alertFieldsDimension() {
        if (this.fields.some(field => field.sizeUnit === 'hectares' ? field.size > 500 : field.size > 1236)) {
            this.$emit('triggerToast', 'We have detected at least one field that exceeds the maximum size of 500 ha, please check it and if necessary modify it on the map.');
        }
        if (this.fields.some(field => field.sizeUnit === 'hectares' ? field.size < 0.0001 : field.size < 0.0002471)) {
            this.$emit('triggerToast', 'We have detected at least one field that has a size smaller than 0.0001 ha, please check it and if necessary modify it on the map.');
        }
    }
    modelEmitPractices(event, field) {
        let practices;
        if (this.isCreationMode) {
            practices = this.CONTROLLER.managementPractices.find((practices) => { return practices.name === event; });
            field.setManagementPractice(practices);
        }
        if (this.isEditionMode) {
            practices = this.metadataLibrary.practices.find((p) => p.id === event.value);
            field.setManagementPractice(practices);
        }
        if (practices) {
            if (this.isEditionMode) {
                this.$emit('setFieldAsEditing', field, 'practices');
            }
        }
    }
    modelEmitCrop(event, field) {
        let crop = new Crop_1.default({});
        if (this.isCreationMode) {
            crop = this.CONTROLLER.crops.find((crop) => { return crop.name === event; });
            field.setCrop(crop);
            this.changeFieldsStyle(field);
            this.$emit('editFarmNameByCropIndividual', field);
        }
        if (this.isEditionMode) {
            crop = this.metadataLibrary.crops.find((crop) => { return crop.id === event.value; });
            field.setCrop(crop);
        }
        if (crop) {
            if (this.isEditionMode) {
                this.$emit('setFieldAsEditing', field, 'crop');
            }
        }
    }
    updateFieldName(field) {
        this.$emit('setFieldAsEditing', field, 'name');
    }
    get fields() {
        return this.fieldsFilters;
    }
    selectField(field) {
        this.pushFn(field);
        this.$emit('drawNewFieldInMap');
    }
    resetGisAreasChecked() {
        this.fieldsChecked = [];
    }
    fieldExists(fieldId) {
        return this.STEP_MODEL.data.selectedFields.some(field => field.id === fieldId);
    }
    checkedGlobalObserver() {
        this.STEP_MODEL.resetSelectedFields();
        this.fieldsChecked = [];
        if (this.isCheckedGlobal) {
            for (const field of this.fields) {
                if (this.isAddingFields) {
                    if (this.editvalidFields.includes(field.id)) {
                        this.fieldsChecked.push(field.id);
                        this.STEP_MODEL.addSelectedFields(field);
                    }
                }
                else {
                    this.fieldsChecked.push(field.id);
                    this.STEP_MODEL.addSelectedFields(field);
                }
            }
            this.$emit('drawNewFieldInMap');
        }
        else if (!this.isCheckedGlobal) {
            if (this.fieldsChecked.length < 1) {
                this.STEP_MODEL.resetSelectedFields();
                this.fieldsChecked = [];
                this.$emit('clearMap');
            }
        }
    }
    changeFieldsStyle(field) {
        var _a, _b;
        const feature = (0, Utils_1.findFeaturerByName)(`${field.id}-${field.fieldName}`, this.map.map);
        if (feature) {
            const fill = new style_1.Fill({ color: field.crop ? `${(_a = field.crop) === null || _a === void 0 ? void 0 : _a.color}50` : '#eebb5460' });
            const stroke = new style_1.Stroke({ color: field.crop ? (_b = field.crop) === null || _b === void 0 ? void 0 : _b.color : '#eebb5460', width: 3 });
            const newStyle = new style_1.Style({ fill: fill, stroke: stroke });
            feature.setStyle(newStyle);
            feature.set('style', newStyle);
        }
    }
    updateSelectedFields() {
        this.resetGisAreasChecked();
        this.isCheckedGlobal = false;
    }
    async pushFn(field) {
        if (this.isCheckedGlobal) {
            this.isCheckedGlobal = false;
        }
        if (this.fieldExists(field.id)) {
            (0, Utils_1.removeFeatureByName)((0, Utils_1.findLayerById)('zone-layer', this.map.map), `${field.id}-${field.fieldName}`);
            /* this.STEP_MODEL.data.selectedFields = this.STEP_MODEL.data.selectedFields.filter((fieldT)=>{fieldT.id !== field.id}); */
            this.STEP_MODEL.removeSelectedField(field.id);
            // this.$emit('clearMap')
            if (this.STEP_MODEL.data.selectedFields.length < 1) {
                this.resetGisAreasChecked();
            }
        }
        else {
            this.STEP_MODEL.addSelectedFields(field);
        }
    }
    parseGeodataToCoordinates(geodata) {
        const match = geodata.match(/\(\((-?[0-9.]+) (-?[0-9.]+)/);
        if (!match)
            throw new Error('Invalid geodata format');
        return [parseFloat(match[1]), parseFloat(match[2])];
    }
    // Cálculo de distancia usando la fórmula de aproximación de la distancia euclidiana
    approximateDistance(lat1, lon1, lat2, lon2) {
        const dLat = (lat2 - lat1) * (Math.PI / 180);
        const dLon = (lon2 - lon1) * (Math.PI / 180);
        const meanLat = ((lat1 + lat2) / 2) * (Math.PI / 180);
        // Aproximación considerando la deformación de la Tierra
        const x = dLon * Math.cos(meanLat);
        const y = dLat;
        return Math.sqrt(x * x + y * y) * this.EARTH_RADIUS_KM * 1000; // Convertimos a metros
    }
    groupFieldsByDistance(fields) {
        const MAX_DISTANCE_KM = 25;
        const groups = [];
        fields.forEach(field => {
            const [lon, lat] = this.parseGeodataToCoordinates(field.geodata);
            // const fieldCoords = fromLonLat([lon, lat]);
            let added = false;
            for (const group of groups) {
                // Verifica si el nuevo campo está a menos de 25 km de **todos** los campos del grupo
                const allWithinDistance = group.fields.every(groupedField => {
                    const [groupLon, groupLat] = this.parseGeodataToCoordinates(groupedField.geodata);
                    return this.approximateDistance(lat, lon, groupLat, groupLon) <= MAX_DISTANCE_KM * 1000;
                });
                if (allWithinDistance) {
                    group.fields.push(field);
                    added = true;
                    break;
                }
            }
            if (!added) {
                groups.push({ groupId: groups.length + 1, fields: [field] });
            }
        });
        return groups;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], FieldsTable.prototype, "map", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], FieldsTable.prototype, "fieldsFilters", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], FieldsTable.prototype, "textFilter", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'create' })
], FieldsTable.prototype, "mode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], FieldsTable.prototype, "isActiveFarm", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], FieldsTable.prototype, "removingField", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], FieldsTable.prototype, "updatingField", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], FieldsTable.prototype, "removedFieldFeedback", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], FieldsTable.prototype, "removedFieldFeedbackMessage", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: -1 })
], FieldsTable.prototype, "updatedFieldRow", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], FieldsTable.prototype, "updatedFieldColumn", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], FieldsTable.prototype, "updatedFieldFeedback", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: '' })
], FieldsTable.prototype, "updatedFieldFeedbackMessage", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: new MetadataLibrary_1.default() })
], FieldsTable.prototype, "metadataLibrary", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], FieldsTable.prototype, "time", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('updatingField')
], FieldsTable.prototype, "evaluatePendingToSave", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('isCheckedGlobal')
], FieldsTable.prototype, "checkedGlobalObserver", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('fields')
], FieldsTable.prototype, "updateSelectedFields", null);
FieldsTable = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { TableBmk: bmk_ui_framework_1.TableBmk, TableHeader: bmk_ui_framework_1.TableHeader, TableHeaderCell: bmk_ui_framework_1.TableHeaderCell, TableBody: bmk_ui_framework_1.TableBody, TableBodyRow: bmk_ui_framework_1.TableBodyRow, TableBodyCell: bmk_ui_framework_1.TableBodyCell, CheckBox: bmk_ui_framework_1.CheckBox, Select: bmk_ui_framework_1.Select, Pencil: lucide_vue_next_1.Pencil, Modal: bmk_ui_framework_1.Modal, Button: bmk_ui_framework_1.Button, Check: lucide_vue_next_1.Check, AlertTriangle: lucide_vue_next_1.AlertTriangle, ChevronsUpDown: lucide_vue_next_1.ChevronsUpDown, Focus: lucide_vue_next_1.Focus, Settings: lucide_vue_next_1.Settings, Trash2: lucide_vue_next_1.Trash2, BinIcon: bmk_ui_framework_1.BinIcon, CheckRoundedIcon: bmk_ui_framework_1.CheckRoundedIcon, SettingsIcon: bmk_ui_framework_1.SettingsIcon, InputField: bmk_ui_framework_1.InputField, SelectField: bmk_ui_framework_1.SelectField, Toggle: Toggle_vue_1.default, XRoundedIcon: bmk_ui_framework_1.XRoundedIcon, PlusIcon: bmk_ui_framework_1.PlusIcon, Toasts: bmk_ui_framework_1.Toasts, Dropdown: floating_vue_1.Dropdown, Loader: bmk_ui_framework_1.Loader, X: lucide_vue_next_1.X, MicroFeedback: bmk_ui_framework_1.MicroFeedback },
        emits: ['confirmFieldRemoval', 'drawNewFieldInMap', 'clearMap', 'updateField', 'addNewField', 'closeToast', 'initializeFieldUpdate', 'initializeFieldRemoval', 'setFieldAsEditing', 'undoFieldEdition']
    })
], FieldsTable);
exports.default = FieldsTable;
